export default __webpack_public_path__ + "static/media/Cypress-Logo.071c7e70.svg";